export default {
    // serviceURL:"http://localhost:8080/order",
    // proxyServiceURL:"http://localhost:8092/proxy",
    serviceURL:"https://vipvpcs.com/api/order",
    proxyServiceURL:"https://vipvpcs.com/api2/proxy",
}